import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as sesionService from "../../services/sesionService";
import { Grid, Card, CardContent, Typography, Box, Snackbar, Alert } from '@mui/material';
import Session from '../../components/Session'
import SessionTherapist from '../../components/SessionTherapist'
import SessionCriterion from '../../components/SessionCriterion'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsSession } from '../../redux/sessionSlice';
import { setEntity as setSessionTherapist, activeValidations as activeSessionTherapist } from '../../redux/sessionTherapistSlice';
import { setEntity as setSessionCriterion, activeValidations as activeSessionCriterion } from '../../redux/sessionCriterionSlice';

const Edit = (props) => {
  const session = useSelector((state) => state.session.entity);
  const nombreTerapeuta = useSelector((state) => state.session.nombreTerapeuta);
  const sessionTherapist = useSelector((state) => state.sessionTherapist.entity);
  const sessionCriterion = useSelector((state) => state.sessionCriterion.entity);
  const sessionValidation = useSelector((state) => state.session.validationMessage);
  const sessionTherapistValidation = useSelector((state) => state.sessionTherapist.validationMessage);
  const sessionCriterionValidation = useSelector((state) => state.sessionCriterion.validationMessage);
  const defaultSessionTherapist = useSelector((state) => state.sessionTherapist.defaultEntity)
  const defaultSessionCriterion = useSelector((state) => state.sessionCriterion.defaultEntity)

  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const dispatch = useDispatch();
  const params = useParams();
  const { isReadOnly, setIsReadOnly } = useMantenimiento("sesion");
  const postEntity = async () => {
    var dataPost = {
      ...session
      , sesionTerapeuta: sessionTherapist
      , sesionCriterio: sessionCriterion
    }

    var ValidationMessages = sessionValidation.concat(sessionTherapistValidation).concat(sessionCriterionValidation);

    if (ValidationMessages.length > 0) {
      dispatch(activeValidationsSession());
      dispatch(activeSessionTherapist());
      dispatch(activeSessionCriterion());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await sesionService.addUpdateSessionWithDetails(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          if (session.id > 0){
            sesionService.getsSesionTerapeutaView(session.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setSessionTherapist(defaultSessionTherapist));
              else
                dispatch(setSessionTherapist(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            sesionService.getsSesionCriterioView(session.id)
            .then((data) => {
                if (data == null || data.length == 0){
                    dispatch(setSessionCriterion(defaultSessionCriterion));
                }
                else {
                    dispatch(setSessionCriterion(data));
                }
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
          }
        })
        .catch(error => {
          setPropsMessage({ severity: "error", message: "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nueva" : "Editar") + " Sesion"}
        backTo={"/session"}
        onSave={postEntity}
        disabled={isReadOnly}
      >
        <Box sx={{ fontWeight: 'bold' }} padding={0}>
          <Typography variant="h7">
            {nombreTerapeuta}
          </Typography>
        </Box>

        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <Session isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <SessionCriterion isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <SessionTherapist isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
